import React, { useState, useEffect, useMemo } from "react";
import { useMarketIndicators } from "../../context/MarketIndicatorContext";
import { useNavigate } from "react-router-dom";
import { FiRefreshCw } from "react-icons/fi";
import HeatMap from "../HeatMap/HeatMap";
import IndexTabs from "../IndexTabs/IndexTabs";
import { nseIndicesOptions } from "../Helper/Helperdata";
import { useMarketSnapshot } from "../../context/MarketSnapshotContext";
import useLivePrices from "../../hooks/useLivePrices";
import { IoMdTrendingUp, IoMdTrendingDown } from "react-icons/io";
import { FiMinusCircle } from "react-icons/fi";
import "./HeatMapDetail.css";

const HeatMapDetail = () => {
  const { getLatestNseData, latestNseData } = useMarketIndicators();
  const {
    loadDashboardIndexMarket,
    dashboardMarketData,
    resetDashboardMarketData,
    dashboardLoading,
    dashboardError,
    dashboardIndexData,

    getDashboardData,
    dashboardData,
    dashboardDataLoading,
    dashboardDataError,
  } = useMarketSnapshot();
  const {
    prices: livePrices,
    isLive,
    lastTickTime,
    subscribeSymbols,
  } = useLivePrices();
  const [selectedIndex, setSelectedIndex] = useState(() => {
    return localStorage.getItem("selectedIndex") || "NIFTY 50";
  });
  const [latestDataIndex, setLatestDataIndex] = useState("");
  const [lastUpdated, setLastUpdated] = useState(null);
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const dashboardRows = useMemo(() => {
    const rows = dashboardData?.data;

    if (Array.isArray(rows)) {
      return rows;
    }

    return Object.values(rows || {});
  }, [dashboardData?.data]);

  const hasDashboardData = dashboardRows.length > 0;
  // const handleIndexSelect = (e) => {
  //   const value = e.target.value;
  //   if (!value) return;

  //   resetDashboardMarketData();
  //   setLatestDataIndex("");
  //   setSelectedIndex(value);
  // };
  const handleIndexSelect = async (e) => {
    const value = e.target.value;

    if (!value || value === selectedIndex) return;

    setSelectedIndex(value);
    localStorage.setItem("selectedIndex", value);

    try {
      await getDashboardData({
        indexName: value,
      });
    } catch (error) {
      console.error("Heatmap index change failed:", error);
    }
  };

  // useEffect(() => {
  //   if (!selectedIndex) return;

  //   localStorage.setItem("selectedIndex", selectedIndex);

  //   const fetchAll = async () => {
  //     await loadDashboardIndexMarket({ indexName: selectedIndex });

  //   };

  //   fetchAll();
  // }, [selectedIndex]);

  useEffect(() => {
    if (!selectedIndex) return;

    localStorage.setItem("selectedIndex", selectedIndex);

    // Dashboard/TestOHLC already loaded this data.
    if (hasDashboardData) {
      console.log("HeatMapDetail: using dashboardData from context");
      return;
    }

    getDashboardData({
      indexName: selectedIndex,
    });
  }, [selectedIndex, hasDashboardData, getDashboardData]);
  // useEffect(() => {
  //   if (!selectedIndex) return;

  //   // Get all stock symbols from dashboard data
  //   const stockSymbols = Object.keys(dashboardMarketData || {});
  //   subscribeSymbols([selectedIndex, ...stockSymbols]);
  // }, [selectedIndex, dashboardMarketData]);
  const dashboardSymbols = useMemo(() => {
    return dashboardRows.map((item) => item?.symbol).filter(Boolean);
  }, [dashboardRows]);

  useEffect(() => {
    if (!selectedIndex) return;

    const symbolsToSubscribe = [
      ...new Set([selectedIndex, ...dashboardSymbols]),
    ];

    subscribeSymbols(symbolsToSubscribe);
  }, [selectedIndex, dashboardSymbols, subscribeSymbols]);

  // const nseIndicesOptions = [
  //   "NIFTY 50",
  //   "NIFTY BANK",
  //   "NIFTY IT",
  //   "NIFTY NEXT 50",
  //   "NIFTY MIDCAP 100",
  // ];

  // console.log("Data is", nseIndexData);
  // const indexSymbolData = nseIndexData?.data?.data;
  const indexSymbolData = latestNseData?.data;
  console.log("Index symbol data", indexSymbolData);

  // const dataToRender1 = indexSymbolData?.filter((item) => item?.priority !== 1);
  const dataToRender1 = useMemo(() => {
    return indexSymbolData?.filter((item) => item?.priority !== 1);
  }, [indexSymbolData]);

  const normalizedIndexData =
    dataToRender1?.map((item) => ({
      ticker_id: item.symbol,
      company: item.symbol,
      ticker: item.symbol,
      price: item.lastPrice,
      open: item.open,
      close: item.previousClose,
      low: item.dayLow,
      high: item.dayHigh,
      volume: item.totalTradedVolume,
      percent_change: item.pChange ?? 0,
    })) || [];

  const dataToRender = normalizedIndexData;
  console.log("Data to render 1", dataToRender1);
  // useEffect(() => {
  //   setSelectedIndex("NIFTY 50");

  //   getLatestNseData("NIFTY 50");
  // }, []);
  console.log("Latest Nse data", latestNseData);
  // const dataToRender1 = nseIndexData?.filter((item) => item?.priority !== 1);
  const dataForIndex = useMemo(() => {
    return indexSymbolData?.filter((item) => item?.priority !== 0);
  }, [indexSymbolData])?.[0];

  // const handleRefresh = () => {
  //   getLatestNseData(selectedIndex);
  // };
  const handleRefresh = async () => {
    if (!selectedIndex) return;

    try {
      await getDashboardData({
        indexName: selectedIndex,
      });
    } catch (error) {
      console.error("Heatmap refresh failed:", error);
    }
  };

  // const currentMarketRows = Object.values(dashboardMarketData || {});
  const currentMarketRows = dashboardRows;

  const latestQuoteTimestamp = currentMarketRows.reduce((latest, item) => {
    const current = new Date(item?.quote_updated_at);

    return current > latest ? current : latest;
  }, new Date(0));

  const latestIntradayTimestamp = currentMarketRows.reduce((latest, item) => {
    const current = new Date(item?.intraday_updated_at);

    return current > latest ? current : latest;
  }, new Date(0));

  const formatTimestamp = (dateValue) => {
    if (!dateValue) return "";

    const now = new Date(dateValue);

    if (isNaN(now)) return "";

    const day = String(now.getDate()).padStart(2, "0");

    const monthNames = [
      "Jan",
      "Feb",
      "Mar",
      "Apr",
      "May",
      "Jun",
      "Jul",
      "Aug",
      "Sep",
      "Oct",
      "Nov",
      "Dec",
    ];

    const month = monthNames[now.getMonth()];

    const year = now.getFullYear();

    const time = now.toLocaleTimeString("en-IN", {
      timeZone: "Asia/Kolkata",
      hour: "2-digit",
      minute: "2-digit",
      second: "2-digit",
      hour12: true,
    });

    return `${day}-${month}-${year} | ${time}`;
  };

  const formattedQuoteTime = formatTimestamp(latestQuoteTimestamp);

  const snapshotStocks = currentMarketRows
    .map((item) => {
      const quote = item?.quote?.data;

      const lastPrice = quote?.last_price;
      const prevClose = quote?.ohlc?.close;

      const pChange =
        prevClose && lastPrice
          ? Number((((lastPrice - prevClose) / prevClose) * 100).toFixed(2))
          : 0;

      return {
        symbol: item?.symbol,
        security_id: item?.security_id,

        lastPrice,
        pChange,

        totalTradedVolume: quote?.volume || 0,
        dayLow: quote?.ohlc?.low,
        dayHigh: quote?.ohlc?.high,
        open: quote?.ohlc?.open,
        previousClose: prevClose,
        yearHigh: quote?.["52_week_high"],

        snapshot: item,
      };
    })
    .filter((item) => item?.symbol && item?.lastPrice);
  // const dataToRender = normalizedData;
  const stocksDb = snapshotStocks.length
    ? snapshotStocks
    : Array.isArray(dataToRender)
      ? dataToRender
      : [];
  // const { advances, declines, unChanged } = useMemo(() => {
  //   let adv = 0;
  //   let dec = 0;
  //   let unc = 0;

  //   stocksDb?.forEach((item) => {
  //     if (item?.pChange > 0) adv++;
  //     else if (item?.pChange < 0) dec++;
  //     else unc++;
  //   });

  //   return {
  //     advances: adv,
  //     declines: dec,
  //     unChanged: unc,
  //   };
  // }, [stocksDb]);
  console.log("Dahsboard index data", dashboardIndexData);
  // const indexQuote = dashboardIndexData?.quote?.data;
  // // const indexLastPrice = indexQuote?.last_price;
  // const liveIndex = livePrices[selectedIndex];

  // const indexLastPrice = liveIndex?.ltp || indexQuote?.last_price;
  // const indexOhlc = indexQuote?.ohlc;
  // // const prevClose = dashboardIndexData?.hist_data?.ohlc?.close;
  // // const prevClose = dashboardIndexData?.quote?.data?.ohlc?.close;
  // const prevClose = dashboardIndexData?.hist_data?.hist?.close?.at(-1);
  // const indexPChange = (
  //   ((indexLastPrice - prevClose) / prevClose) *
  //   100
  // ).toFixed(2);
  const liveIndex = livePrices?.[selectedIndex];

  const storedIndexPrice = Number(dashboardData?.selectedIndex?.last_price);

  const storedPrevClose = Number(dashboardData?.selectedIndex?.prev_close);

  const liveIndexPrice = Number(liveIndex?.ltp);

  const indexLastPrice = Number.isFinite(liveIndexPrice)
    ? liveIndexPrice
    : storedIndexPrice;

  const prevClose = storedPrevClose;

  const calculatedIndexChange =
    Number.isFinite(indexLastPrice) &&
    Number.isFinite(prevClose) &&
    prevClose !== 0
      ? Number((((indexLastPrice - prevClose) / prevClose) * 100).toFixed(2))
      : 0;

  const livePercentChange = Number(liveIndex?.percentChange);

  const indexPChange = Number.isFinite(livePercentChange)
    ? livePercentChange
    : calculatedIndexChange;
  console.log("indexPerchange", indexPChange);
  console.log("Dahsboard data", dashboardIndexData);
  console.log("Dashboard data", dashboardMarketData);
  // const heatMapSnapshotData = Object.values(dashboardMarketData || {}).map(
  // const heatMapSnapshotData = dashboardRows.map(

  // (item) => {
  //     const quote = item?.quote?.data;
  //     const nse = item?.nse;

  //     const lastPrice = quote?.last_price;
  //     const prevClose = quote?.ohlc?.close;
  //     const security_id = item?.security_id;

  //     const pChange =
  //       prevClose && lastPrice
  //         ? Number((((lastPrice - prevClose) / prevClose) * 100).toFixed(2))
  //         : 0;

  //     return {
  //       symbol: item?.symbol,
  //       identifier: item?.symbol,
  //       security_id,

  //       lastPrice,
  //       pChange,
  //       change:
  //         lastPrice && prevClose
  //           ? Number((lastPrice - prevClose).toFixed(2))
  //           : 0,

  //       open: quote?.ohlc?.open,
  //       previousClose: prevClose,
  //       dayLow: quote?.ohlc?.low,
  //       dayHigh: quote?.ohlc?.high,
  //       totalTradedVolume: quote?.volume || 0,

  //       yearHigh: quote?.["52_week_high"],
  //       yearLow: quote?.["52_week_low"],

  //       meta: nse?.meta || {},
  //     };
  //   },
  // );
  const heatMapSnapshotData = useMemo(() => {
    return dashboardRows.map((item) => {
      const quote = item?.quote?.data;
      const nse = item?.nse;

      const live = livePrices?.[item?.symbol];

      const lastPrice = live?.ltp ?? quote?.last_price;

      const prevClose = item?.prev_close ?? quote?.ohlc?.close;

      const livePercentChange = Number(live?.percentChange);

      const pChange = Number.isFinite(livePercentChange)
        ? livePercentChange
        : prevClose && lastPrice
          ? Number(
              (
                ((Number(lastPrice) - Number(prevClose)) / Number(prevClose)) *
                100
              ).toFixed(2),
            )
          : 0;

      return {
        symbol: item?.symbol,
        identifier: item?.symbol,
        security_id: item?.security_id,

        lastPrice,
        pChange,

        change:
          lastPrice && prevClose
            ? Number((Number(lastPrice) - Number(prevClose)).toFixed(2))
            : 0,

        open: live?.open ?? quote?.ohlc?.open,

        previousClose: prevClose,

        dayLow: live?.low ?? quote?.ohlc?.low,

        dayHigh: live?.high ?? quote?.ohlc?.high,

        totalTradedVolume: live?.volume ?? quote?.volume ?? 0,

        yearHigh: quote?.["52_week_high"],
        yearLow: quote?.["52_week_low"],

        meta: nse?.meta || {},
      };
    });
  }, [dashboardRows, livePrices]);

  // Merge live prices into heatmap data
  const liveHeatMapData = useMemo(() => {
    const baseData = heatMapSnapshotData.length
      ? heatMapSnapshotData
      : dataToRender1 || [];

    if (!isLive || !Object.keys(livePrices).length) return baseData;

    return baseData.map((stock) => {
      const live = livePrices[stock.symbol] || livePrices[stock.security_id];
      if (!live?.ltp) return stock;

      const prevClose = stock.previousClose || stock.close;
      const livePrice = live.ltp;
      const livePChange = prevClose
        ? Number((((livePrice - prevClose) / prevClose) * 100).toFixed(2))
        : stock.pChange;

      return {
        ...stock,
        lastPrice: livePrice,
        pChange: livePChange,
        change: prevClose
          ? Number((livePrice - prevClose).toFixed(2))
          : stock.change,
        dayHigh: live.high || stock.dayHigh,
        dayLow: live.low || stock.dayLow,
        volume: live.volume || stock.totalTradedVolume,
      };
    });
  }, [heatMapSnapshotData, dataToRender1, livePrices, isLive]);
  const { advances, declines, unChanged } = useMemo(() => {
    let adv = 0;
    let dec = 0;
    let unc = 0;

    liveHeatMapData.forEach((stock) => {
      const change = Number(stock?.pChange);

      if (!Number.isFinite(change) || change === 0) {
        unc++;
      } else if (change > 0) {
        adv++;
      } else {
        dec++;
      }
    });

    return {
      advances: adv,
      declines: dec,
      unChanged: unc,
    };
  }, [liveHeatMapData]);
  return (
    <>
      <div className="index-row ">
        {/* <div className="back-btn">
          <button
            className="rec-btn trendpro-back-btn"
            onClick={() => navigate(-1)}
          >
            Back
          </button>
        </div> */}
        <div className="select-option dropdown testpage-inner-dropdown">
          <label className="test-page-label">Choose Index</label>

          <div className="select-span-index">
            <select
              className="test-select"
              onChange={handleIndexSelect}
              value={selectedIndex}
            >
              <option value="">Select</option>
              {nseIndicesOptions?.map((item) => (
                <option key={item} value={item}>
                  {item}
                </option>
              ))}
            </select>

            <span
              className="index-price-data"
              style={{
                color:
                  indexPChange > 0
                    ? "#16a34a"
                    : indexPChange < 0
                      ? "#dc2626"
                      : "#6b7280",
              }}
            >
              {indexLastPrice} ({indexPChange > 0 ? "+" : ""}
              {indexPChange}% )
            </span>
          </div>
        </div>

        <IndexTabs />
      </div>

      <div className="heatmap-dropdown-div">
        {/* <div className="select-option dropdown testpage-inner-dropdown">
          <label className="test-page-label">Choose Index</label>

          <select
            className="test-select"
            onChange={handleIndexSelect}
            value={selectedIndex}
          >
            <option value="">Select</option>
            {nseIndicesOptions?.map((item) => (
              <option key={item} value={item}>
                {item}
              </option>
            ))}
          </select>
          <span
            className="index-price-data"
            style={{
              color:
                indexPChange > 0
                  ? "#16a34a"
                  : indexPChange < 0
                    ? "#dc2626"
                    : "#6b7280",
              fontSize: "1.2rem",
              fontWeight: "600",
              alignSelf: "center",
            }}
          >
            
            {indexLastPrice} ({indexPChange > 0 ? "+" : ""}
            {indexPChange}% )
          </span>
        </div> */}
        {/* <div className="select-option dropdown testpage-inner-dropdown">
          <label className="test-page-label">Choose Index</label>

          <div className="select-span-index">
            <select
              className="test-select"
              onChange={handleIndexSelect}
              value={selectedIndex}
            >
              <option value="">Select</option>
              {nseIndicesOptions?.map((item) => (
                <option key={item} value={item}>
                  {item}
                </option>
              ))}
            </select>

            <span
              className="index-price-data"
              style={{
                color:
                  indexPChange > 0
                    ? "#16a34a"
                    : indexPChange < 0
                      ? "#dc2626"
                      : "#6b7280",
              }}
            >
             
              {indexLastPrice} ({indexPChange > 0 ? "+" : ""}
              {indexPChange}% )
            </span>
          </div>
        </div> */}
      </div>

      {/* <h2 className="heatmap-head">{selectedIndex}</h2> */}
      <div className="stock-table-stats">
        {/* <h1 className="stocktest-h1">
          {selectedIndex}
          <span
            style={{
              color:
                dataForIndex?.pChange > 0
                  ? "#16a34a"
                  : dataForIndex?.pChange < 0
                    ? "#dc2626"
                    : "#6b7280",
              fontSize: "1.1rem",

              marginLeft: "10px",
            }}
          >
            {dataForIndex?.lastPrice} ({dataForIndex?.pChange > 0 ? "+" : ""}
            {dataForIndex?.pChange}%)
          </span>
        </h1> */}
        <div className="hm-legend-container">
          <div className="hm-legend-item hm-lg-5">5</div>
          <div className="hm-legend-item hm-lg-3">3</div>
          <div className="hm-legend-item hm-lg-1">1</div>
          <div className="hm-legend-item hm-lg-0">0%</div>
          <div className="hm-legend-item hm-lg--1">-1</div>
          <div className="hm-legend-item hm-lg--3">-3</div>
          <div className="hm-legend-item hm-lg--5">-5</div>
        </div>
        <div className="outer-test-card">
          <div className="test-card-stats">
            <p style={{ color: "#16a34a" }}>
              <IoMdTrendingUp />
              Advances - {advances}
              {/* <InfoTooltip text={DASHTOOL?.advances} /> */}
            </p>
            <p style={{ color: "#dc2626" }}>
              <IoMdTrendingDown />
              Declines - {declines}
              {/* <InfoTooltip text={DASHTOOL?.declines} /> */}
            </p>
            <p style={{ color: "#6b7280" }}>
              <FiMinusCircle />
              Unchanged - {unChanged}
              {/* <InfoTooltip text={DASHTOOL?.unchanged} /> */}
            </p>
          </div>
        </div>

        <div className="last-updated-head">
          {/* {lastUpdated && <span>As on {lastUpdated}</span>} */}
          <span>As on {formattedQuoteTime}</span>
          <FiRefreshCw
            onClick={handleRefresh}
            size={18}
            style={{
              cursor: "pointer",
              transition: "0.2s",
            }}
            onMouseOver={(e) => (e.target.style.color = "#2fd18a")}
            onMouseOut={(e) => (e.target.style.color = "#9ca3af")}
          />
        </div>
      </div>

      {/* <HeatMap data={dataToRender1} loading={loading} /> */}
      {/* <HeatMap
        data={liveHeatMapData}
        // data={heatMapSnapshotData.length ? heatMapSnapshotData : dataToRender1}
        loading={dashboardLoading || loading}
      /> */}
      <HeatMap
        data={liveHeatMapData}
        loading={dashboardDataLoading && dashboardRows.length === 0}
      />
    </>
  );
};

export default HeatMapDetail;
